import React from 'react'
import { Form, InputNumber, Select } from 'antd'
import PropTypes from 'prop-types'
import TextArea from 'antd/lib/input/TextArea'

const ZhanyltpashtarForm = ({
  form,
  text,
  status,
  type,
  index,
  setAudioFile,
  audioFileRef
}) => {
  const FormItem = Form.Item
  return (
    <Form form={form} layout="vertical" hideRequiredMark>
      <FormItem
        key="status"
        label="Статус документа"
        name="status"
        rules={[
          {
            required: true,
            message: `Пожалуйста, выберите статус`
          }
        ]}
        initialValue={status}
      >
        <Select placeholder="Выберите статус" mode="single">
          <Select.Option key="active" value="active">
            Активный
          </Select.Option>
          <Select.Option key="inactive" value="inactive">
            Скрытый
          </Select.Option>
        </Select>
      </FormItem>
      <FormItem
        key="text"
        label="Текст"
        name="text"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите текст`
          }
        ]}
        initialValue={text}
      >
        <TextArea placeholder="Текст" />
      </FormItem>
      <div style={{ marginBottom: '3%' }}>
        <>Аудио</>
        <input
          type="file"
          accept="audio/*"
          ref={audioFileRef}
          onChange={event => {
            setAudioFile(event.target.files[0])
          }}
        />
      </div>
      <FormItem
        key="type"
        label="Сложность"
        name="type"
        rules={[
          {
            required: true,
            message: `Пожалуйста, выберите сложность`
          }
        ]}
        initialValue={type}
      >
        <Select placeholder="Выберите сложность" mode="single">
          <Select.Option key="easy" value="easy">
            Легкий
          </Select.Option>
          <Select.Option key="medium" value="medium">
            Средний
          </Select.Option>
          <Select.Option key="hard" value="hard">
            Сложный
          </Select.Option>
        </Select>
      </FormItem>
      <FormItem
        key="index"
        label="Очередность"
        name="index"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите очередность`
          }
        ]}
        initialValue={index}
      >
        <InputNumber min={1} placeholder="Очередность" />
      </FormItem>
    </Form>
  )
}

ZhanyltpashtarForm.propTypes = {
  form: PropTypes.objectOf(PropTypes.any).isRequired
}

export default ZhanyltpashtarForm
